import { render, staticRenderFns } from "./AirtimeHistory.vue?vue&type=template&id=71d43cb4&scoped=true&"
import script from "./AirtimeHistory.vue?vue&type=script&lang=js&"
export * from "./AirtimeHistory.vue?vue&type=script&lang=js&"
import style0 from "./AirtimeHistory.vue?vue&type=style&index=0&id=71d43cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d43cb4",
  null
  
)

export default component.exports